import { createFileRoute } from '@tanstack/react-router';
import { PageShell } from '~/components/layout';
import {
  CtaBanner,
  DownloadQr,
  FaqAccordion,
  FeatureBlock,
  Hero,
  InvestorsGrid,
  ProvidersStrip,
  TestimonialGrid,
  TextSection,
} from '~/components/sections';
import { cryptoDeposit, cryptoHero, cryptoProviders, cryptoSend } from '~/content/crypto';
import { safeSpaceSection, trustedBySection } from '~/content/shared';
import { pageHeadMeta } from '~/lib/seo';
import heroCss from '~/styles/hero.css?inline';

export const Route = createFileRoute('/cryptocurrecy')({
  head: () =>
    pageHeadMeta({
      title: 'Convert between Stablecoin and USD — nsave',
      description:
        'Deposit USDC and USDT from any major exchange, convert automatically to USD, and send funds to any stablecoin wallet.',
      path: '/cryptocurrecy',
      inlineStyles: [heroCss],
    }),
  component: CryptoPage,
});

function CryptoPage() {
  return (
    <PageShell>
      <Hero
        content={cryptoHero}
        statsSlot={
          <ProvidersStrip providers={cryptoProviders} className="mt-[104px] md:mt-[124px]" />
        }
      />
      <TextSection content={trustedBySection} />
      <FeatureBlock content={cryptoDeposit} imagePosition="left" />
      <FeatureBlock content={cryptoSend} imagePosition="right" ctaSlot={<DownloadQr />} />
      <InvestorsGrid />
      <TextSection content={safeSpaceSection} sectionClassName="max-md:!my-[40px]" />
      <TestimonialGrid />
      <FaqAccordion />
      <CtaBanner />
    </PageShell>
  );
}
